import { render, staticRenderFns } from "./FaqModalForm.vue?vue&type=template&id=bd1c9f28"
import script from "./FaqModalForm.vue?vue&type=script&lang=js"
export * from "./FaqModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports